import React from 'react';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { FDSecondaryActionIconButton } from '@facet-wealth/design';
import { pick } from 'Helpers/Affordances';
import { DataValueMap } from 'Helpers/Testing';

const BackButtonPicker = () => {
  const { pageContentResource, loadPageContentLink } = usePageContentContext();

  return pick(pageContentResource, {
    [fr.relationships.back.name]:
  <FDSecondaryActionIconButton
    onClick={() => {
      loadPageContentLink(pageContentResource.relationship(fr.relationships.back.name).link('related'));
    }}
    label={'Back'}
    size={'lg'}
    icon={'arrowLeft'}
    {...DataValueMap.init('proposal-preview-back-button').build()}
  />,
  }, null);
};

export default BackButtonPicker;
